export default "__VITE_ASSET__2ac2b5b8__"